import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { getTopImage } from '../util/Helper';

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = { }
  }
  
  handleSubmitClick = (e, id) => {
    e.preventDefault();
    localStorage.setItem('kwizda3', null);
    this.props.history.push("/regisztracio")
  }
  handleEditClick = (e, id) => {
    e.preventDefault();
    this.props.history.push("/termekszerkesztes?termek=" + id)
  }
  gotoItemPage(id){
    //console.log("go to item page:" + id);
    this.props.history.push("/termek?id=" + id)
  }

  render() { 
    let colorClass = "kwizda-item-color-" + this.props.item.color.replace("#","");
    //console.log("name:" + this.props.item.name);
    
    return ( 
      <div className="kwizda-item">
          <div className={"kwizda-item-header "}>
            <div className="kwizda-item-top-container">
              {/*<h4><ItemName name={this.props.item.name} imageheight={26}></ItemName></h4>*/}
              {this.props.item.id && Number(this.props.item.id) < 23 ?
                <img alt='cimke' className="kwizda-item-top-container-image" src={"img/kwizda3_cimkek/" + getTopImage(this.props.item.id)}/>
                :
                <div style={{width: '100%', height: 257, borderRadius: 25, position:'relative'}} className={colorClass}>
                  <img alt='cimke' className="kwizda-item-top-container-image testaaa" src={"img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail.png"}/>
                  <div style={{position:'absolute', top:85, left:50, fontSize: 22, fontFamily: 'Muli-Bold', inlineSize: 158, overflowWrap: "break-word", lineHeight:'23px'}} >{this.props.item.name}</div>
                </div>
              }
            </div>
          </div>
          <div className="kwizda-item-desc">
            <div className="kwizda-item-problem">{this.props.item.problem_name}</div>
            <div className="kwizda-item-culturesandusage">
              <div className="kwizda-item-label">Kísérlet megvalósítás időzítése:</div>
              <div>{this.props.item.proposed_time}</div>
              <div className="kwizda-item-label">Megvalósítás helye:</div>
              <div>{this.props.item.agent}</div>
              <div className="kwizda-item-label">Helyszínek száma:</div>
              <div>{this.props.item.dose}</div>
              <div className="kwizda-item-label">Dokumentáció módja:</div>
              <div>{this.props.item.type}</div>
            </div>

            <div className="kwizda-item-gotopagebutton" onClick={() =>this.gotoItemPage(this.props.item.id)}>
              <span>Kísérlet részletei itt!</span>
            </div>
          </div>
          <div>
            <button className="kwizda-button kwizda-item-register-button" 
              onClick={(e)=> this.handleSubmitClick(e, this.props.item.id)}>Regisztrálok</button>
          </div>
          <div className="kwizda-item-deadline2">
            <div>Jelentkezési határidő: {this.props.item.deadline}</div>
          </div>
      </div>
     );
  }
}
 
export default withRouter(Item);
